<app-projects-project-data-editor [forceFormValidationVisibility]="forceFormValidationVisibility"></app-projects-project-data-editor>
<div class="divider"></div>


<ng-container>
    <app-projects-project-documents-loader [forceFormValidationVisibility]="forceFormValidationVisibility">
    </app-projects-project-documents-loader>
</ng-container>


<!--<ng-container *ngIf="isInternalUser()">-->
<!--    <app-projects-project-documents-viewer>-->
<!--    </app-projects-project-documents-viewer>-->
<!--    <div class="divider"></div>-->
<!--    <app-projects-employee-editor [forceFormValidationVisibility]="forceFormValidationVisibility" ></app-projects-employee-editor>-->
<!--    <div class="divider"></div>-->
<!--    <app-warranty-notes-editor></app-warranty-notes-editor>-->
<!--    <div class="divider"></div>-->
<!--    <app-offer-text-modules-editor> </app-offer-text-modules-editor>-->
<!--</ng-container>-->
